import axios from "axios";
import  Constant from '../../containers/Services/constant';

const themeUrl = "gettheme";  
const registerUrl = "register";  
const loginUrl = "logincheck";  
const footerUrl = "footercontact";  
const pagesUrl = "getpagecontent";  
const userdataUrl = "getuserdata";  
const resendotpUrl = "resendotp";  
const completeprofileUrl = "completeprofile";  
const blogsDataUrl = "getblogs";  
const stateDataUrl = "getStates";  
const cityDataUrl = "getCity";  
const blogslugDataUrl = "getblogsbyslug";  
const blogcategoryDataUrl = "getblogsbycategory";  
const blogtagDataUrl = "getblogsbytags";  
const footerDataUrl = "footerdata";  
const clientDataUrl = "getclientdata";  
const getquestionsUrl = "getquestionsdata";  
const savequestionUrl = "savequestiondata";  
const getriskprofileUrl = "calcriskscore";  
const getfeaturedblogUrl = "getfeaturedblogs";  
const savegoalsettingsdataUrl = "savegoalsettingsdata";  
const getprevquesdataUrl = "getprevquestiondata";  
const saveriskscoreUrl = "saveuserriskscore";  
const getgoaldataUrl = "getgoaldata";  
const showusergraphdataUrl = "showusergraphdata";  
const subscribenewsletterUrl = "subscribenewsletter";  
const canfetchUrl = "canfetch";  
const apiloginUrl = "apilogin";  
const savecanstatusUrl = "savecanstatus";  
const resetpasswordUrl = "resetpassword";  
const canregisterstepUrl = "canregisterstep";  
const getCountriesUrl = "getCountries";  
const getBanksUrl = "getBanks";  
const getusercandataUrl = "getusercandata";  
const getMutualFundUrl = "getmutualFundData";  
const canproofuploadUrl = "canproofupload";  
const canproofremoveUrl = "canproofremove";  
const canuserproofdataUrl = "canuserproofdata";  
const canstatusUrl = "canstatus";  
const mutualfundamcUrl = "getmutualfundamc";  
const getmutualfundcategoryUrl = "getmutualfundcategory";  
const getmutualfundsubcategoryUrl = "getmutualfundsubcategory";  
const getmutualfunddividendUrl = "getmutualfunddividend";  
const getmutualFunddetailDataUrl = "getmutualFunddetailData";  
const purchasetransactionUrl = "purchasetransaction";  
const getmutualInvestmentDataUrl = "getmutualInvestmentData";  
const canvalidationUrl = "canvalidation";  
const editprofileUrl = "editprofile";  
const changepasswordUrl = "changepassword";  
const getusercanbankdataUrl = "getusercanbankdata";  
const siptransactionUrl = "siptransaction";  
const getselectedmutualfundsUrl = "getselectedmutualfunds";  
const epayeezzregistrationUrl = "epayeezzregistration";  
const epayeezzstatusUrl = "epayeezzstatus"; 
const savecontactdataUrl = "savecontactdata";
const getmutualFundDatarecommendedUrl = "getmutualFundDatarecommended";
const gettransactiondata = "gettransactiondata";
const getgoalgraphdata = "getgoalgraphdata";
const saveuserbankdataUrl = "saveuserbankdata";
const getusertransactionsdataUrl = "getusertransactionsdata";
const getuseralltransactionsdataUrl = "getuseralltransactionsdata";
const getMICRUrl = "https://ifsc.razorpay.com/";
const getinvestorconcentUrl = "getinvestorconcent";
const getcheckconcentstatusUrl ="getcheckconcentstatus"
const getpreviousholdingsdataUrl ="getpreviousholdingsdata"
const getgoalstoxholdingsdataUrl ="getgoalstoxholdingsdata"
const sendtxnotpUrl ="sendtxnotp"
const verifytxnotpUrl ="verifytxnotp"
const getredeemfoliosUrl ="getredeemfolios"
const redeemfundDataUrl ="redeemfundData"
const redeemtransactionUrl ="redeemtransaction";
const getmutualFundSwitchDataUrl = "getmutualFundSwitchData";
const switchtransactionUrl = "switchtransaction";
const logoutUrl = "logout";
const changpasswordUrl = "changpassword";
const checkresetpasswordurlexpireUrl = "checkresetpasswordurlexpire"

function getauthtoken(){
let token = localStorage.getItem('AUTH_TOKEN');
let Authtoken = '';
if(token !=null && token !='' && token !=undefined){
    Authtoken = token;
}
const config = {
  headers: { 'X-Authorization': `Bearer ${Authtoken}` }
};
return config;
}

const client = axios.create({
    baseURL: Constant.API_URL,
  });


export class ApiService {
    registerPostRequest(request) {
      return client.post(registerUrl, request);
    }
    loginPostRequest(request) {
      return client.post(loginUrl, request);
    }
    getUserData(request){
      return client.post(userdataUrl,request,getauthtoken());
    }
    footerGetRequest() {
      return client.get(footerUrl);
    }
    saveQuestionData(request){
      return client.post(savequestionUrl,request,getauthtoken());
    }
    questionGetRequest() {
      return client.get(getquestionsUrl);
    }
    themeGetRequest() {
      return client.get(themeUrl);
    }
    blogGetRequest() {
      return client.get(blogsDataUrl);
    }
    pagesPostRequest(request){
      return client.post(pagesUrl,request);
    }

    resendotpPostRequest(request){
      return client.post(resendotpUrl,request);
    }

    completeprofile(request){
      return client.post(completeprofileUrl,request , getauthtoken());
    }
    getstates(){
      return client.get(stateDataUrl);
    }
    getcities(request){
      return client.post(cityDataUrl,request);
    }
    getblogbyslug(request){
      return client.post(blogslugDataUrl,request);
    }
    getblogbycategory(request){
      return client.post(blogcategoryDataUrl,request);
    }
    getblogbytags(request){
      return client.post(blogtagDataUrl,request);
    }

    getfooterdata(request){
      return client.post(footerDataUrl,request);
    }

    getClientsData(request){
      return client.post(clientDataUrl,request);
    }
     getriskprofile(request){
      return client.post(getriskprofileUrl,request ,getauthtoken() );
    }
    getfeaturedblogs(request){
      return client.post(getfeaturedblogUrl,request);
    }
    submitgoalsettingsdata(request){
      return client.post(savegoalsettingsdataUrl,request , getauthtoken());
    }
    getprevquesdata(request){
      return client.post(getprevquesdataUrl,request);
    }
    saveriskscore(request){
      return client.post(saveriskscoreUrl,request, getauthtoken());
    }
    // getgoaldata(request){
    //   return client.post(getgoaldataUrl,request, getauthtoken());
    // }
    getusergraphdata(request){
      return client.post(showusergraphdataUrl,request,getauthtoken());
    }

    subscribenewsletter(request){
      return client.post(subscribenewsletterUrl,request);
    }
    canfetch(request){
      return client.post(canfetchUrl,request , getauthtoken());
    }
    // mfuapilogin(request){
    //   return client.post(apiloginUrl,request);
    // }
    savecanstatus(request){
      return client.post(savecanstatusUrl,request,getauthtoken());
    }
    resetpassword(request){
      return client.post(resetpasswordUrl,request);
    }
    canregisterstep(request){
      return client.post(canregisterstepUrl,request , getauthtoken());
    }
    getBanks(){
      return client.get(getBanksUrl , getauthtoken());
    }
    getCountries(){
      return client.get(getCountriesUrl , getauthtoken());
    }
    // getusercandata(request){
    //   return client.post(getusercandataUrl,request);
    // }

    mutualFundGetRequest(request) {
      return client.post(getMutualFundUrl,request , getauthtoken());
    }

    canproofupload(request) {
      return client.post(canproofuploadUrl,request,getauthtoken());
    }

    canproofremove(request) {
      return client.post(canproofremoveUrl,request,getauthtoken());
    }

    canuserproofdata(request) {
      return client.post(canuserproofdataUrl,request , getauthtoken());
    }

    // canstatus(request) {
    //   return client.post(canstatusUrl,request);
    // }
    getmutualfundamc() {
      return client.get(mutualfundamcUrl, getauthtoken());
    }
    getmutualfundcategory() {
      return client.get(getmutualfundcategoryUrl, getauthtoken());
    }
    getmutualfunddividend() {
      return client.get(getmutualfunddividendUrl, getauthtoken());
    }
    getmutualfundsubcategory(request) {
      return client.post(getmutualfundsubcategoryUrl,request, getauthtoken());
    }
    getmutualFunddetailData(request) {
      return client.post(getmutualFunddetailDataUrl,request, getauthtoken());
    }
    purchasetransaction(request) {
      return client.post(purchasetransactionUrl,request,getauthtoken());
    }
    getmutualInvestmentData(request) {
      return client.post(getmutualInvestmentDataUrl,request,getauthtoken());
    }
    canvalidation(request) {
      return client.post(canvalidationUrl,request,  getauthtoken());
    }

  //  editprofile (request) {
  //     return client.post(editprofileUrl,request);
  //   }

    changepassword(request) {
      return client.post(changepasswordUrl,request,getauthtoken());
    }

    getusercanbankdata(request) {
      return client.post(getusercanbankdataUrl,request,getauthtoken());
    }

    siptransaction(request) {
      return client.post(siptransactionUrl,request, getauthtoken());
    }
    
    getselectedmutualfunds(request) {
      return client.post(getselectedmutualfundsUrl,request,getauthtoken());
    }

    epayeezzregistration(request) {
      return client.post(epayeezzregistrationUrl,request,getauthtoken());
    }
    savecontactdata(request) {
      return client.post(savecontactdataUrl,request);
    }
    epayeezzstatus(request) {
      return client.post(epayeezzstatusUrl,request ,  getauthtoken());
    }
    datarecommendedGetRequest() {
      return client.get(getmutualFundDatarecommendedUrl,  getauthtoken());
    }
    gettransactiondata(request) {
      return client.post(gettransactiondata,request,  getauthtoken());
    }
    getgoalgraphdata(request) {
      return client.post(getgoalgraphdata,request,  getauthtoken());
    }
    saveuserbankdata(request) {
      return client.post(saveuserbankdataUrl,request , getauthtoken());
    }
    getusertransactionsdata(request) {
      return client.post(getusertransactionsdataUrl,request, getauthtoken());
    }
    getuseralltransactionsdata(request){
      return client.post(getuseralltransactionsdataUrl,request , getauthtoken());
    }
    getMICRGetRequest(IFSC) {
      return client.get(getMICRUrl+IFSC);
    }
    getinvestorconcentPostRequest(request){
      return client.post(getinvestorconcentUrl,request,getauthtoken());
    }
    getcheckconcentstatusPostRequest(request){
      return client.post(getcheckconcentstatusUrl,request,getauthtoken());
    }
    getpreviousholdingsdataPostRequest(request){
      return client.post(getpreviousholdingsdataUrl,request,getauthtoken());
    }
    sendtxnotp(request){
      return client.post(sendtxnotpUrl,request,getauthtoken());
    }
    verifytxnotp(request){
      return client.post(verifytxnotpUrl,request,getauthtoken());
    }
    getgoalstoxholdingsdataPostRequest(request){
      return client.post(getgoalstoxholdingsdataUrl,request,getauthtoken());
    }

    getredeemfoliosPostRequest(request){
      return client.post(getredeemfoliosUrl,request,getauthtoken());
    }
    redeemfundDataPostRequest(request){
      return client.post(redeemfundDataUrl,request,getauthtoken());
    }
    redeemtransactionPostRequest(request){
      return client.post(redeemtransactionUrl,request,getauthtoken());
    }
    getmutualFundSwitchDataPostRequest(request){
      return client.post(getmutualFundSwitchDataUrl,request,getauthtoken());
    }
    switchtransactionPostRequest(request){
      return client.post(switchtransactionUrl,request,getauthtoken());
    }
    logoutPostRequest(request){
      return client.post(logoutUrl,request , getauthtoken());
    }
    changpasswordPostRequest(request){
      return client.post(changpasswordUrl,request);
    }
    checkresetpasswordurlexpirePostRequest(request){
      return client.post(checkresetpasswordurlexpireUrl,request, getauthtoken());
    }
}